module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_autre"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-003"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Chief abbreviations")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('div', {
    staticClass: "dev"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-001"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("ANET")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Ancient Near Eastern Texts"), _c('sup', [_vm._v("2")])])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("BASOR")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Bulletin of the American Schools of Oriental Research")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("BZAW")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Beihefte zum Zeitschrift für die alttestamentliche Wissenschaft")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("CBQ")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Catholic Biblical Quarterly")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("DJD")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Discoveries in the Judaean Desert")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("E")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Elohistic source")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("HTR")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Harvard Theological Review")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("HUCA")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Hebrew Union College Annual")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("IBD")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("The Illustrated Bible Dictionary")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("IDB")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("The Interpreter’s Dictionary of the Bible")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("IDBS")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("The Interpreter’s Dictionary of the Bible")]), _vm._v(", Supplementary volume, 1976")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("IEJ")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Israel Exploration Journal")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("J")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Yahwistic source")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("JAOS")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Journal of the American Oriental Society")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("JBL")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("JJS")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Journal of Jewish Studies")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("JQR")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Jewish Quarterly Review")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("JSS")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Journal of Semitic Studies")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("P")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Priestly source")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("PEQ")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Palestine Exploration Quarterly")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("RB")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Revue Biblique")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("TB")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Tyndale Bulletin")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('i', [_vm._v("VT")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Vetus Testamentum")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("VTS")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Supplements to Vetus Testamentum")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("ZAW")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("Commentaries")]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-002"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Baentsch")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Exodus, Leviticus, Numeri ")]), _vm._v("by B. Baentsch (Hand-Kommentar zum Alten Testament), 1903.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Binns")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("The Book of Numbers ")]), _vm._v("by L. E. Binns (Westminster Commentaries), 1927.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Calvin")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Commentaries on the Four Last Books of Moses ")]), _vm._v("by J. Calvin, 1563 (ET, 1852).")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Cazelles")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Les Nombres")]), _c('sup', [_vm._v("3")]), _vm._v(" by H. Cazelles (Bible de Jérusalem) 1971.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Dillmann")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Die Bücher Numeri, Deuteronomium und Josua ")]), _c('sup', [_vm._v("2 ")]), _vm._v("by Dillmann (Kurzgefasstes exegetisches Handbuch zum Alten Testament), 1886.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Gispen")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Het boek Numeri I–II ")]), _vm._v("by W. H. Gispen (Commentaar op het Oude Testament), 1959, 1964.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Gray")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("A Critical and Exegetical Commentary on Numbers ")]), _vm._v("by G. B. Gray (International Critical Commentary), 1903.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Greenstone")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Numbers with Commentary ")]), _vm._v("by J. H. Greenstone (The Holy Scriptures), 1939.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Heinisch")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Das Buch Numeri übersetzt und erklärt ")]), _vm._v("by P. Heinisch (Die heilige Schrift des Alten Testaments), 1936.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Keil")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("The Pentateuch ")]), _vm._v("III by C.F. Keil (Biblical Commentary on the Old Testament).")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Noordtzij")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Het boek Numeri ")]), _vm._v("by A. Noordtzij (Korte Verklaring der Heilige Schrift), 1941.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Noth")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Numbers: A Commentary ")]), _vm._v("by M. Noth (Old Testament Library), 1968.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Rashi")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Pentateuch with Rashi’s Commentary: Numbers ")]), _vm._v("(ET by M. Rosenbaum and A.M. Silbermann).")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Saalschütz")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Das Mosaische Recht ")]), _c('sup', [_vm._v("2")]), _vm._v(" by J. L. Saalschütz, 1853.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Snaith")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Leviticus and Numbers ")]), _vm._v("by N.H. Snaith (New Century Bible), 1967.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Sturdy")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Numbers ")]), _vm._v("by J. Sturdy (Cambridge Bible Commentary), 1976.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("de Vaulx")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("Les Nombres ")]), _vm._v("by J. de Vaulx (Sources Bibliques), 1972.")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_vm._v("Wenham")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('i', [_vm._v("The Book of Leviticus ")]), _vm._v("by G. J. Wenham (New International Commentary on the Old Testament), 1979.")])])])])])])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-002"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('h2', {
    staticClass: "int_niv1"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Texts and versions")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-003"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "2",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("AV")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Authorized Version (King James)")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BHS")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Biblia Hebraica Stuttgartensia")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LXX")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("The Septuagint (pre-Christian Greek version of OT)")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MT")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Massoretic Text")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NEB")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New English Bible")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NIV")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("New International Version")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("RSV")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Revised Standard Version")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TEV")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Today’s English Version")])])])])])])])])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30ed1363","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre4.vue
// module id = 72
// module chunks = 0